import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import InterModularSidebar from "../Layouts/InterModularSidebar";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
// import { ShortHistoryTriage } from '../Layouts/ShortHistoryTriage';
import { Preview, print } from "react-html2pdf";

export class NewbornWardRound extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      Presentingcomplaint: "",
      Assessment: "",
      Diagnosis: "",
      Plan: "",
      Discharge: "",
      DischargeInstructions: "",
      patientName: "",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {
    let id = localStorage.getItem("currentVisitId");
    const headers = {
      token: localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      visitid: localStorage.getItem("currentVisitId"),
    };
    axios
      .get(this.api_url+"/newborn/data", { headers: headers })
      .then((response) => {
        var babyname = response.data[0].name;
        this.setState({ patientName: babyname });
      });
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }
  onTableChange(event) {}

  proceedEvent(event) {
    window.location.href = "/triage/admission/triage";
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    event.preventDefault();
    console.log(localStorage.getItem("objectLength"));
    var objectLength = localStorage.getItem("objectLength");

    this.setState({
      Year: this.state.tablevaluesglobal[0]["Year"],
    });

    console.log(this.state);

    for (var i = 0; i < Object.keys(this.state.tablevaluesglobal).length; i++) {
      // console.log(this.state.tablevaluesglobal[i]['Year'])

      var dict = {
        Presentingcomplaint: this.state.Presentingcomplaint,
        Assessment: this.state.Presentingcomplaint,
        Diagnosis: this.state.Presentingcomplaint,
        Plan: this.state.Presentingcomplaint,
        Discharge: this.state.Presentingcomplaint,
        DischargeInstructions: this.state.Presentingcomplaint,
        treatment: {
          Route: this.state.tablevaluesglobal[i]["Route"],
          DrugName: this.state.tablevaluesglobal[i]["DrugName"],
          Dosage: this.state.tablevaluesglobal[i]["Dosage"],
          Frequency: this.state.tablevaluesglobal[i]["Frequency"],
          Duration: this.state.tablevaluesglobal[i]["Duration"],
          DrugAdministration:
            this.state.tablevaluesglobal[i]["DrugAdministration"],
          midwifenursename: this.state.tablevaluesglobal[i]["midwifenursename"],
          remarks: this.state.tablevaluesglobal[i]["remarks"],
        },
      };

      axios
        .post(this.api_url+"wardround/ward1", dict, {
          headers: headers,
        })
        .then((response) => {
          console.log(response);
          // /triage/antenatal/history

          if (response.data["status"]) {
            $(".alert-success").show();
            setTimeout(function () {
              // window.location.href = '/gynecology2/antenatal/history'
            }, 500);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      this.setState({
        Year: "1212",
      });

      trimobj.Route = data[i][0];
      trimobj.DrugName = data[i][1];
      trimobj.Dosage = data[i][2];
      trimobj.Frequency = data[i][3];
      trimobj.Duration = data[i][4];
      trimobj.DrugAdministration = data[i][6];
      trimobj.midwifenursename = data[i][7];
      trimobj.remarks = data[i][8];

      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
  }
  handleTableChange(event) {}

  getTableValues(event) {
    let tablevalues = this.formatTableOutput(event);
    // console.log(tablevalues);
  }

  render() {
    //Editable table variables
    const data = [["", "", "", "", "", "", "", ""]];

    const columns = [
      "Sn",
      "Route",
      "Drug Name",
      "Dosage",
      "Frequency",
      "Duration",
      "Name of Doctor",
      "Doctor`s Remarks",
    ];

    const font16 = { fontSize: "22px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };

    var PatientName = this.state.patientName;

    const {
      Presentingcomplaint,
      Assessment,
      Diagnosis,
      Plan,
      Discharge,
      DischargeInstructions,
    } = this.state;
    return (
      <div>
        <Headers />

        <InterModularSidebar />
        <main className="content-container">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4">
                <div className="col-md-12 font-weight-bold p-1">
                  <p className="" style={font16}>
                    {PatientName}`s Ward Round
                  </p>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      {" "}
                      Presenting Complaint
                    </h6>
                    <textarea
                      className="form-control"
                      rows="6"
                      onChange={this.handleChange}
                      value={Presentingcomplaint}
                      name="Presentingcomplaint"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Assessment
                    </h6>
                    <textarea
                      className="form-control"
                      rows="6"
                      onChange={this.handleChange}
                      value={Assessment}
                      name="Assessment"
                      type="text"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Diagnosis
                    </h6>
                    <textarea
                      className="form-control"
                      rows="6"
                      onChange={this.handleChange}
                      value={Diagnosis}
                      name="Diagnosis"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="col-md-6 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Plan
                    </h6>
                    <textarea
                      rows="6"
                      className="form-control"
                      onChange={this.handleChange}
                      value={Plan}
                      name="Plan"
                      type="text"
                      required
                    ></textarea>
                  </div>
                </div>
              </div>
              <div className="form-row pt-4">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}></p>
                </div>

                <div className="col-md-12 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Discharge
                    </h6>
                    <textarea
                      rows="6"
                      className="form-control"
                      onChange={this.handleChange}
                      value={Discharge}
                      name="Discharge"
                      type="text"
                      required
                    ></textarea>
                  </div>
                  <h6 className="text-capitalize" style={fontFamilyNunito}>
                    Discharge Instructions
                  </h6>
                  <textarea
                    rows="6"
                    className="form-control"
                    onChange={this.handleChange}
                    value={DischargeInstructions}
                    name="DischargeInstructions"
                    type="text"
                    required
                  ></textarea>
                </div>
              </div>

              <div className="form-row mb-2 pt-4">
                <div className="col-md-12 text-lg-center font-weight-bold p-1">
                  <MDBCard>
                    <MDBCardHeader
                      tag="h3"
                      className="text-center font-weight-bold text-capitalise py-4"
                    >
                      Treatment
                    </MDBCardHeader>
                    <MDBCardBody>
                      <MDBTableEditable
                        onChange={(value) => this.handleTableChange(value)}
                        getValue={(value) => this.getTableValues(value)}
                        myParentTrigger={this.state.myParentTrigger}
                        id="#editablecard"
                        data={data}
                        columns={columns}
                        striped
                        bordered
                      />
                    </MDBCardBody>
                  </MDBCard>
                </div>
              </div>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Record Saved Successfully.
              </div>

              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default NewbornWardRound;
